// extracted by mini-css-extract-plugin
module.exports = {"border":"EmailOtp_border__gAQ3_","inputStyle":"EmailOtp_inputStyle__Y7YC6","text":"EmailOtp_text___CwyJ","timer":"EmailOtp_timer__FiNtE"};